import { first } from '@gov-nx/core/types';
import { useRezaSelection } from '../Reza/useRezaSelection';
import type { ApplicantDetailsPersonsProps } from '@gov-nx/ui/types';
import { useRobPersonQuery } from '../Person/useRobPersonQuery';
import { useRosBusinessPersonQuery } from '../Person/useRosBusinessPersonQuery';

export const useApplicantPersonsDetailsByReza = ({
	isBusinessPersonAllowed,
}: {
	isBusinessPersonAllowed: boolean;
}): ApplicantDetailsPersonsProps => {
	const { isRezaSelected } = useRezaSelection();
	const { data: individualPerson } = useRobPersonQuery();
	const { data: businessPerson } = useRosBusinessPersonQuery({
		enabled: isBusinessPersonAllowed,
	});

	if (!isBusinessPersonAllowed) {
		return {
			individualPerson,
			businessPerson: undefined,
		};
	}

	return {
		individualPerson: !isRezaSelected ? individualPerson : undefined,
		businessPerson: isRezaSelected
			? first(businessPerson?.seznam ?? [])
			: undefined,
	};
};
